import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getProviderUtilizationOverview,
  type ProviderUtilizationOverviewResult,
} from '@services/api/dashboard/provider-utilization.api'

export function useProviderUtilizationOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<ProviderUtilizationOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getProviderUtilizationOverview, {
    enabled,
    queued,
  })
}
